import {waitForPropertyOnWindow} from '../../../src/shared/helpers/load-script';

export function ReCaptchaService(
    $window
) {
    const service = this;
    
    service.getToken = function getToken(siteKey, action) {
        return waitForPropertyOnWindow('grecaptcha', 2)
            .then(() => {
                return $window.grecaptcha.execute(siteKey, {action});
            });
    };
    
    return service;
}

ReCaptchaService.$inject = [
    '$window'
];
